export let
	URL_PREFIX;

switch(true) {
	case (process.env.NODE_ENV === 'development'):
	case (process.env.NODE_ENV === '"development"'):
		URL_PREFIX = 'http://localhost:8081'
		break
	case (process.env.NODE_ENV === 'production'):
	case (process.env.NODE_ENV === '"production"'):
		URL_PREFIX = 'https://app.techinterview.co'
		break
}

export const REGISTER_ACCOUNT = 'register';

export const COMPANY_LIST = [
	{
		title: 'Facebook',
		icon: '/static/companies/icons/facebook-icon.svg',
		url: `${URL_PREFIX}/company/facebook`
	},
	{
		title: 'Google',
		icon: '/static/companies/icons/google-icon.svg',
		url: `${URL_PREFIX}/company/google`
	},
	{
		title: 'Microsoft',
		icon: '/static/companies/icons/microsoft-icon.svg',
		url: `${URL_PREFIX}/company/microsoft`
	},
	{
		title: 'Amazon',
		icon: '/static/companies/icons/amazon-icon.svg',
		url: `${URL_PREFIX}/company/amazon`
	},
	{
		title: 'Apple',
		icon: '/static/companies/icons/apple-icon.svg',
		url: `${URL_PREFIX}/company/apple`
	},
	{
		title: 'Snapchat',
		icon: '/static/companies/icons/snapchat-icon.svg',
		url: `${URL_PREFIX}/company/snapchat`
	},
	{
		title: 'Yelp',
		icon: '/static/companies/icons/yelp-icon.svg',
		url: `${URL_PREFIX}/company/yelp`
	},
	{
		title: 'LinkedIn',
		icon: '/static/companies/icons/linkedin-icon.svg',
		url: `${URL_PREFIX}/company/linkedin`
	},
	{
		title: 'Twitter',
		icon: '/static/companies/icons/twitter-icon.svg',
		url: `${URL_PREFIX}/company/twitter`
	},
	{
		title: 'Bloomberg',
		icon: '/static/companies/icons/bloomberg-icon.svg',
		url: `${URL_PREFIX}/company/bloomberg`
	},
	{
		title: 'Uber',
		icon: '/static/companies/icons/uber-icon.svg',
		url: `${URL_PREFIX}/company/uber`
	},
	{
		title: 'Goldman',
		icon: '/static/companies/icons/goldman-icon.svg',
		url: `${URL_PREFIX}/company/goldman`
	},
]


// WEBPACK FOOTER //
// ./src/constants.js